var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vg-content"},[_c('van-image',{staticClass:"logo",attrs:{"width":"110","height":"110","src":_vm.srcExpired}}),_c('div',{staticClass:"title"},[_vm._v("登录已过期")]),_c('div',{staticClass:"text"},[_vm._v("请前往猎豹TP端重新登录")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }